module.exports = __webpack_public_path__ + "static/media/foto6.b2229a3e.png";